import { createStore, combineReducers, applyMiddleware, compose } from "redux";
import {
  persistStore,
  persistReducer
} from "redux-persist"; 
import storage from "redux-persist/es/storage";
import thunk from 'redux-thunk';
import { composeWithDevTools } from "redux-devtools-extension";
import formReducer from "../../src/reducers/form";
import formsReducer from "../../src/reducers/forms";
import sentItemsReducer from "../../src/reducers/sentItems";
import notificationsReducer from "../../src/reducers/notifications";
import formArrayReducer from "../../src/reducers/formArray";
import informedWebAppReducer from "../../src/reducers/informedWebApp";
import tasksReducer from "../../src/reducers/tasks";
import usersReducer from "../../src/reducers/users";

const middleware = [ thunk ];
const config = {
  key: "form", 
  storage,
  blacklist: ['submitting']
};

const config3 = {
  key: "formArray",
  storage
};
const config4 = {
  key: "sentItems",
  storage
};

const config5 = {
  key: "notifications",
  storage,
  blacklist: ['filterUnread']
};

const config1 = {
  key: "forms",
  storage
};

const config2 = {
    key: "informedWebApp",
    storage,
    blacklist: ['application_version']
  };

const configTasks = {
    key: "tasks",
    storage
};

const configUsers = {
  key: "users",
  storage
};

const form = persistReducer(config, formReducer);
const forms = persistReducer(config1, formsReducer);
const sentItems = persistReducer(config4, sentItemsReducer);
const notifications = persistReducer(config5, notificationsReducer);
const informedWebApp = persistReducer(config2, informedWebAppReducer);
const formArray = persistReducer(config3, formArrayReducer);
const tasks = persistReducer(configTasks, tasksReducer);
const users = persistReducer(configUsers, usersReducer);

const rootReducer = combineReducers({
    form,
    forms,
    sentItems,
    notifications,
    formArray,
    informedWebApp,
    tasks,
    users
});

const app = {
}

function configureStore() {
  let store = createStore(rootReducer,
    app,
    composeWithDevTools(applyMiddleware(...middleware))
      );
  let persistor = persistStore(store);
  //persistor.purge();
  return { persistor, store };
}

export default configureStore;


// WEBPACK FOOTER //
// ./src/store/configureStore.js